var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overview-topbar white-bkg by-1 p-5 mt--5 ml--5" },
    [
      _c(
        "div",
        { staticClass: "overview-topbar-wrapper container-big m-auto" },
        _vm._l(_vm.dataTopBar, function(topbar, indexTopbar) {
          return _c("div", { key: indexTopbar }, [
            indexTopbar == "main"
              ? _c(
                  "div",
                  { staticClass: "overview-topbar-main-content clearfix" },
                  [
                    _c(
                      "div",
                      { staticClass: "info-wrapper dinlineb pt-2" },
                      [
                        _c("staff-picker", {
                          attrs: { currentStaffId: topbar.id }
                        }),
                        _vm._v(" "),
                        _vm._l(topbar.datas, function(data, indexData) {
                          return data.value != ""
                            ? _c(
                                "div",
                                {
                                  key: indexData,
                                  staticClass: "dinlineb valign-middle ml-5"
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "info-label m-0 pt-2" },
                                    [_vm._v(_vm._s(data.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "info-value" }, [
                                    _vm._v(_vm._s(data.value))
                                  ])
                                ]
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "actions-wrapper fright pl-4 bl-1 fs-3 semibold"
                      },
                      [
                        _vm.dataTopBar.actions
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-dropdown",
                                  {
                                    attrs: { trigger: "click" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "dropdown",
                                          fn: function() {
                                            return [
                                              _c(
                                                "el-dropdown-menu",
                                                _vm._l(
                                                  _vm.dataTopBar.actions.options
                                                    .links.datas,
                                                  function(link, keylink) {
                                                    return _c(
                                                      "el-dropdown-item",
                                                      { key: keylink },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: link.value
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(link.label)
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "el-dropdown-link block px-2 py-1",
                                        attrs: { href: "javascript:;" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.dataTopBar.actions.options
                                                .links.title
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "block px-2 py-1",
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                _vm.showDetails = !_vm.showDetails
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$l10n.__("Voir plus")) +
                                "\n                        "
                            ),
                            !_vm.showDetails
                              ? _c("i", {
                                  staticClass: "fa icon-caret-down-fillout ml-2"
                                })
                              : _c("i", {
                                  staticClass: "fa icon-caret-top-fillout ml-2"
                                })
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            indexTopbar == "sub"
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDetails,
                        expression: "showDetails"
                      }
                    ],
                    staticClass: "submenu-wrapper mt-4 pt-5 bt-1"
                  },
                  _vm._l(topbar.subData, function(block, indexBlock) {
                    return _c(
                      "div",
                      {
                        key: indexBlock,
                        staticClass:
                          "submenu dinlineb prelative valign-top span_6"
                      },
                      [
                        _c("h3", { staticClass: "info-category m-0" }, [
                          _vm._v(_vm._s(block.title))
                        ]),
                        _vm._v(" "),
                        _vm._l(block.datas, function(subBlock, indexSubBlock) {
                          return _c("div", { key: indexSubBlock }, [
                            subBlock.value != ""
                              ? _c("div", [
                                  _c(
                                    "p",
                                    { staticClass: "info-label m-0 pt-2" },
                                    [_vm._v(_vm._s(subBlock.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "info-value" }, [
                                    _vm._v(_vm._s(subBlock.value))
                                  ])
                                ])
                              : _vm._e()
                          ])
                        }),
                        _vm._v(" "),
                        block.staffs
                          ? _c("div", [
                              _c("p", { staticClass: "info-label m-0 pt-2" }, [
                                _vm._v(
                                  _vm._s(_vm.$l10n.__("Membres du groupe"))
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "staff-container m-0" },
                                _vm._l(block.staffs, function(
                                  staff,
                                  indexStaff
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: indexStaff,
                                      staticClass: "dinlineb mt-2 ml-2"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: _vm.urlStaff(staff) }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "avatar",
                                              class: {
                                                "avatar-picture":
                                                  staff.avatar.type == "picture"
                                              }
                                            },
                                            [
                                              staff.avatar.type == "picture"
                                                ? _c("img", {
                                                    attrs: {
                                                      src: staff.avatar.value
                                                    }
                                                  })
                                                : _c("span", [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          staff.avatar.value
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }